'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _analyticsData = require('./analytics-data.component');

var _analyticsData2 = _interopRequireDefault(_analyticsData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analyticsModule = _angular2.default.module('app.containers.analytics-data', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('analyticsData', {
    url: '/analytics-data',
    template: '<analytics-data></analytics-data>'
  });
}).component('analyticsData', _analyticsData2.default);

exports.default = analyticsModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/analytics-data/analytics-data.js
 **/